import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=00fa85e4&scoped=true"
import script from "./InvoiceForm.vue?vue&type=script&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./InvoiceForm.vue?vue&type=style&index=0&id=00fa85e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa85e4",
  null
  
)

export default component.exports